
import { mapGetters } from 'vuex'
import { Currency } from '~/plugins/Currency'
import { convertM2H } from '~/plugins/date'
export default {
  props: {
    date: {
      default: () => ({ val: '', text: '' }),
    },
    time: {
      default: '',
    },
    item: {
      default: () => {},
    },
    product: {
      default: () => {},
    },
  },
  computed: {
    ...mapGetters({
      getUserIP: 'user/getUserIP',
    }),
  },
  methods: {
    Currency,
    convertM2H(n, gmt = false) {
      return convertM2H(n, this.getUserIP.offset, true, gmt)
    },
  },
}
